import { SvgIcon as MuiSvgIcon, SvgIconProps as MuiSvgIconProps } from "@mui/material";

export const CommentIcon = (props: MuiSvgIconProps) => (
  <MuiSvgIcon {...props} data-testid="comment-icon" viewBox="0 0 16 16">
    <path
      d="M6 6.9502C6 6.70166 6.20148 6.5 6.45001 6.5H9.54999C9.79852 6.5 10 6.70166 10 6.9502C10 7.19873 9.79852 7.3999 9.54999 7.3999H6.45001C6.20148 7.3999 6 7.19873 6 6.9502Z"
      fill="var(--gravx-color-neutral-on-light-grey-7)"
    />
    <path
      d="M6.12555 8.13818C6.04779 8.21924 6 8.3291 6 8.4502C6 8.69873 6.20148 8.8999 6.45001 8.8999H9.54999C9.69861 8.8999 9.83038 8.82812 9.91229 8.71729C9.96741 8.64258 10 8.55029 10 8.4502C10 8.28955 9.91565 8.14844 9.78876 8.06885C9.71954 8.02539 9.6377 8 9.54999 8H6.45001C6.32257 8 6.20746 8.05322 6.12555 8.13818Z"
      fill="var(--gravx-color-neutral-on-light-grey-7)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.46887 11.0312L4.72101 11.7788C4.58667 11.9131 4.43292 11.9438 4.25983 11.8706C4.17834 11.8359 4.11603 11.7891 4.07288 11.729C4.02429 11.6616 4 11.5781 4 11.4785V5.34668C4 5.1123 4.08252 4.9126 4.2475 4.74756C4.3382 4.65674 4.43939 4.59082 4.55109 4.5498C4.64258 4.5166 4.74109 4.5 4.84668 4.5H11.1533C11.3878 4.5 11.5875 4.58252 11.7525 4.74756C11.9175 4.9126 12 5.1123 12 5.34668V10.1846C12 10.4189 11.9175 10.6187 11.7525 10.7837C11.686 10.8501 11.6139 10.9033 11.5361 10.9429C11.4208 11.002 11.2933 11.0312 11.1533 11.0312H5.46887ZM5.1629 10.1846H11.1533V5.34668H4.84668V10.5029L5.1629 10.1846Z"
      fill="var(--gravx-color-neutral-on-light-grey-7)"
    />
  </MuiSvgIcon>
);
